import { PaymentSettingsRepository } from '@lib/api/repository/payment-settings/payment-settings.repository';
import { PaymentSettings, PaymentSettingsInput } from '@lib/types';

import { Requester } from '../clients';

export default class PaymentSettingsAPI implements PaymentSettingsRepository {
  async get(signal?: AbortSignal) {
    return (
      await Requester.get<PaymentSettings>(
        '/marketplace/admin/payment-settings', { signal },
      )
    ).data;
  }

  async update(input: PaymentSettingsInput) {
    return (
      await Requester.patch<PaymentSettings>(
        '/marketplace/admin/payment-settings',
        { body: input },
      )
    ).data;
  }
}
